var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleStoreSeeklogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 217.6 64.1",
    style: {
      enableBackground: "new 0 0 217.6 64.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Drop_x0020_Shadow{fill:none;}\r\n\t.Round_x0020_Corners_x0020_2_x0020_pt{fill:#FFFFFF;stroke:#1D1D1B;stroke-miterlimit:10;}\r\n\t.Live_x0020_Reflect_x0020_X{fill:none;}\r\n\t.Bevel_x0020_Soft{fill:url(#SVGID_1_);}\r\n\t.Dusk{fill:#FFFFFF;}\r\n\t.Foliage_GS{fill:#FFDC00;}\r\n\t.Pompadour_GS{fill-rule:evenodd;clip-rule:evenodd;fill:#51ADE1;}\r\n\t.st0{display:none;fill:#020A0A;}\r\n\t.st1{fill:#A5A1A2;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.7222,
    y1: 24.2131,
    x2: 101.4293,
    y2: 24.9202
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#E2E2E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    style: {
      stopColor: "#D6D6DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5393,
    style: {
      stopColor: "#C1C2C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7233,
    style: {
      stopColor: "#A5A6A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9067,
    style: {
      stopColor: "#808384"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B6E6E"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.4,63.2H8.2c-4.1,0-7.4-3.3-7.4-7.4V8.2c0-4.1,3.3-7.4,7.4-7.4h201.2c4.1,0,7.4,3.3,7.4,7.4v47.7 C216.8,59.9,213.5,63.2,209.4,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.4,64.1H8.2c-4.5,0-8.2-3.7-8.2-8.2V8.2C0,3.7,3.7,0,8.2,0h201.2c4.5,0,8.2,3.7,8.2,8.2v47.7 C217.6,60.4,213.9,64.1,209.4,64.1z M8.2,1.6c-3.6,0-6.6,2.9-6.6,6.6v47.7c0,3.6,2.9,6.6,6.6,6.6h201.2c3.6,0,6.6-2.9,6.6-6.6V8.2 c0-3.6-2.9-6.6-6.6-6.6H8.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.4,18.2l-0.9,3h-2l3.4-10.5h2.5l3.4,10.5h-2.1l-1-3H72.4z M75.5,16.8l-0.8-2.6c-0.2-0.6-0.4-1.4-0.5-2h0 c-0.2,0.6-0.3,1.3-0.5,2l-0.8,2.6H75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.7,13.6l1.2,3.9c0.2,0.7,0.4,1.3,0.5,1.9h0c0.1-0.6,0.3-1.2,0.5-1.9l1.2-3.9h2l-2.9,7.6h-1.9l-2.8-7.6 H81.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.9,19.4c0,0.7,0,1.4,0.1,1.8h-1.7l-0.1-0.8h0c-0.5,0.6-1.2,1-2.2,1c-1.5,0-2.4-1.1-2.4-2.3 c0-1.9,1.7-2.9,4.5-2.9v-0.1c0-0.5-0.2-1.3-1.5-1.3c-0.7,0-1.5,0.2-2,0.6L89,14.1c0.6-0.3,1.5-0.7,2.7-0.7c2.4,0,3.1,1.5,3.1,3.2 V19.4z M93,17.5c-1.4,0-2.7,0.3-2.7,1.4c0,0.7,0.5,1.1,1.1,1.1c0.8,0,1.3-0.5,1.5-1c0-0.1,0-0.3,0-0.4V17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.5,12.5c-0.6,0-1.1-0.5-1.1-1c0-0.6,0.4-1,1.1-1c0.7,0,1.1,0.5,1.1,1C99.6,12,99.2,12.5,98.5,12.5 L98.5,12.5z M97.6,21.2v-7.6h1.9v7.6H97.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.3,10.1h1.9v11.1h-1.9V10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.9,19.4c0,0.7,0,1.4,0.1,1.8h-1.7l-0.1-0.8h0c-0.5,0.6-1.2,1-2.2,1c-1.5,0-2.4-1.1-2.4-2.3 c0-1.9,1.7-2.9,4.5-2.9v-0.1c0-0.5-0.2-1.3-1.5-1.3c-0.7,0-1.5,0.2-2,0.6l-0.4-1.2c0.6-0.3,1.5-0.7,2.7-0.7c2.4,0,3.1,1.5,3.1,3.2 V19.4z M111,17.5c-1.4,0-2.7,0.3-2.7,1.4c0,0.7,0.5,1.1,1.1,1.1c0.8,0,1.3-0.5,1.5-1c0-0.1,0-0.3,0-0.4V17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.6,10.1h1.9v4.5h0c0.5-0.7,1.3-1.2,2.4-1.2c1.9,0,3.2,1.5,3.2,3.9c0,2.7-1.7,4.1-3.4,4.1 c-1,0-1.9-0.4-2.4-1.3h0l-0.1,1.1h-1.6c0-0.5,0.1-1.4,0.1-2.1V10.1z M117.5,18.1c0,0.2,0,0.3,0,0.5c0.2,0.8,0.9,1.3,1.7,1.3 c1.2,0,1.9-1,1.9-2.5c0-1.3-0.6-2.4-1.9-2.4c-0.8,0-1.5,0.6-1.7,1.4c0,0.1-0.1,0.3-0.1,0.5V18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.4,10.1h1.9v11.1h-1.9V10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.5,17.9c0,1.4,1.1,2,2.3,2c0.9,0,1.5-0.1,2.1-0.3l0.3,1.3c-0.7,0.3-1.6,0.5-2.7,0.5 c-2.5,0-3.9-1.5-3.9-3.8c0-2.1,1.3-4.1,3.7-4.1c2.5,0,3.3,2,3.3,3.7c0,0.4,0,0.6-0.1,0.8H131.5z M134.8,16.6 c0-0.7-0.3-1.9-1.6-1.9c-1.2,0-1.7,1.1-1.8,1.9H134.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.1,21.4c-2.1,0-3.8-1.5-3.8-3.9c0-2.5,1.6-4,3.9-4c2.3,0,3.8,1.6,3.8,3.9C150,20.1,148,21.4,146.1,21.4 L146.1,21.4z M146.1,20c1.1,0,1.9-1.1,1.9-2.6c0-1.2-0.5-2.6-1.8-2.6c-1.4,0-1.9,1.3-1.9,2.6C144.2,18.9,145,20,146.1,20L146.1,20 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.2,15.9c0-0.9,0-1.6-0.1-2.3h1.7l0.1,1.1h0c0.3-0.6,1.2-1.3,2.4-1.3c1.3,0,2.7,0.9,2.7,3.3v4.5h-1.9v-4.3 c0-1.1-0.4-1.9-1.5-1.9c-0.8,0-1.3,0.5-1.5,1.1c-0.1,0.2-0.1,0.4-0.1,0.6v4.5h-1.9V15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M168,11.6v2h1.8V15H168v3.3c0,0.9,0.2,1.4,1,1.4c0.3,0,0.5,0,0.7-0.1l0,1.5c-0.3,0.1-0.8,0.2-1.4,0.2 c-0.7,0-1.3-0.2-1.7-0.6c-0.4-0.4-0.6-1.1-0.6-2.1V15H165v-1.4h1.1v-1.4L168,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.9,10.1h1.9v4.5h0c0.2-0.4,0.6-0.7,1-0.9c0.4-0.2,0.8-0.3,1.3-0.3c1.3,0,2.7,0.9,2.7,3.3v4.5h-1.9v-4.3 c0-1.1-0.4-1.9-1.5-1.9c-0.7,0-1.3,0.5-1.5,1.1c-0.1,0.2-0.1,0.4-0.1,0.6v4.6h-1.9V10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M182.9,17.9c0,1.4,1.1,2,2.3,2c0.9,0,1.5-0.1,2.1-0.3l0.3,1.3c-0.7,0.3-1.6,0.5-2.7,0.5 c-2.5,0-3.9-1.5-3.9-3.8c0-2.1,1.3-4.1,3.7-4.1c2.5,0,3.3,2,3.3,3.7c0,0.4,0,0.6-0.1,0.8H182.9z M186.2,16.6 c0-0.7-0.3-1.9-1.6-1.9c-1.2,0-1.7,1.1-1.8,1.9H186.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.6,31.4c0-5.2,4.3-7.7,4.5-7.9c-2.4-3.6-6.2-4-7.6-4.1c-3.2-0.3-6.3,1.9-7.9,1.9c-1.7,0-4.1-1.9-6.8-1.8 c-3.5,0.1-6.7,2.1-8.5,5.2c-3.7,6.3-0.9,15.7,2.6,20.8c1.8,2.5,3.8,5.3,6.5,5.2C34,50.6,35,49,38.1,49c3.1,0,4.1,1.7,6.8,1.6 c2.8,0,4.6-2.5,6.3-5.1c2-2.9,2.8-5.7,2.9-5.9C54,39.7,48.6,37.6,48.6,31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.4,16.1c1.4-1.8,2.4-4.2,2.1-6.6c-2,0.1-4.6,1.4-6.1,3.1c-1.3,1.5-2.5,4-2.2,6.4 C39.6,19.2,41.9,17.8,43.4,16.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.5,50.3h-3.7l-2-6.3h-7L72,50.3h-3.6l6.9-21.4h4.3L86.5,50.3z M80.2,41.3l-1.8-5.6 c-0.2-0.6-0.6-1.9-1.1-4h-0.1c-0.2,0.9-0.6,2.3-1,4l-1.8,5.6H80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.3,42.4c0,2.6-0.7,4.7-2.1,6.2c-1.3,1.4-2.9,2-4.7,2c-2,0-3.5-0.7-4.4-2.2h-0.1v8.1h-3.4V39.9 c0-1.7,0-3.3-0.1-5.1h3l0.2,2.4h0.1c1.1-1.8,2.9-2.8,5.2-2.8c1.8,0,3.3,0.7,4.6,2.2C103.6,38.1,104.3,40,104.3,42.4 M100.8,42.5 c0-1.5-0.3-2.7-1-3.7c-0.7-1-1.7-1.5-3-1.5c-0.8,0-1.6,0.3-2.3,0.8c-0.7,0.6-1.1,1.3-1.4,2.2c-0.1,0.4-0.2,0.8-0.2,1v2.6 c0,1.1,0.3,2.1,1,2.8c0.7,0.8,1.6,1.2,2.7,1.2c1.3,0,2.3-0.5,3-1.5C100.4,45.4,100.8,44.1,100.8,42.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122,42.4c0,2.6-0.7,4.7-2.1,6.2c-1.3,1.4-2.8,2-4.7,2c-2,0-3.5-0.7-4.4-2.2h-0.1v8.1h-3.4V39.9 c0-1.7,0-3.3-0.1-5.1h3l0.2,2.4h0.1c1.1-1.8,2.9-2.8,5.2-2.8c1.8,0,3.3,0.7,4.6,2.2C121.4,38.1,122,40,122,42.4 M118.5,42.5 c0-1.5-0.3-2.7-1-3.7c-0.7-1-1.7-1.5-3-1.5c-0.8,0-1.6,0.3-2.3,0.8c-0.7,0.6-1.1,1.3-1.3,2.2c-0.1,0.4-0.2,0.8-0.2,1v2.6 c0,1.1,0.3,2.1,1,2.8c0.7,0.8,1.6,1.2,2.7,1.2c1.3,0,2.3-0.5,3-1.5C118.2,45.4,118.5,44.1,118.5,42.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.9,44.3c0,1.8-0.6,3.3-1.9,4.5c-1.4,1.3-3.3,1.9-5.8,1.9c-2.3,0-4.2-0.4-5.6-1.3l0.8-2.9 c1.5,0.9,3.2,1.4,5,1.4c1.3,0,2.3-0.3,3-0.9c0.7-0.6,1.1-1.4,1.1-2.3c0-0.9-0.3-1.6-0.9-2.2c-0.6-0.6-1.6-1.1-3-1.7 c-3.8-1.4-5.6-3.5-5.6-6.1c0-1.8,0.7-3.2,2-4.3c1.3-1.1,3.1-1.7,5.2-1.7c2,0,3.6,0.3,4.9,1l-0.9,2.8c-1.2-0.7-2.6-1-4.1-1 c-1.2,0-2.2,0.3-2.8,0.9c-0.6,0.5-0.9,1.2-0.9,1.9c0,0.8,0.3,1.5,1,2.1c0.6,0.5,1.6,1.1,3.1,1.7c1.8,0.7,3.2,1.6,4.1,2.6 C141.5,41.5,141.9,42.8,141.9,44.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.3,37.4h-3.8v7.5c0,1.9,0.7,2.9,2,2.9c0.6,0,1.1-0.1,1.5-0.2l0.1,2.6c-0.7,0.3-1.6,0.4-2.7,0.4 c-1.4,0-2.4-0.4-3.2-1.2c-0.8-0.8-1.1-2.2-1.1-4.2v-7.8h-2.3v-2.6h2.3V32l3.4-1v3.8h3.8V37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.4,42.4c0,2.4-0.7,4.3-2,5.9c-1.4,1.6-3.3,2.4-5.7,2.4c-2.3,0-4.1-0.8-5.4-2.3c-1.3-1.5-2-3.4-2-5.7 c0-2.4,0.7-4.4,2.1-5.9c1.4-1.5,3.3-2.3,5.6-2.3c2.3,0,4.1,0.8,5.5,2.3C169.7,38.2,170.4,40.1,170.4,42.4 M166.8,42.5 c0-1.4-0.3-2.6-0.9-3.7c-0.7-1.2-1.7-1.9-3.1-1.9c-1.4,0-2.4,0.6-3.1,1.9c-0.6,1-0.9,2.3-0.9,3.7c0,1.4,0.3,2.6,0.9,3.7 c0.7,1.2,1.8,1.8,3.1,1.8c1.3,0,2.3-0.6,3.1-1.9C166.5,45.2,166.8,44,166.8,42.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M181.5,37.8c-0.3-0.1-0.7-0.1-1.1-0.1c-1.2,0-2.1,0.5-2.8,1.4c-0.6,0.8-0.9,1.8-0.9,3.1v8.1h-3.4l0-10.6 c0-1.8,0-3.4-0.1-4.9h3l0.1,3h0.1c0.4-1,0.9-1.8,1.7-2.4c0.8-0.6,1.6-0.8,2.5-0.8c0.3,0,0.6,0,0.9,0.1V37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M196.9,41.8c0,0.6,0,1.1-0.1,1.6h-10.3c0,1.5,0.5,2.7,1.5,3.5c0.9,0.7,2,1.1,3.4,1.1c1.5,0,2.9-0.2,4.2-0.7 l0.5,2.4c-1.5,0.6-3.2,1-5.2,1c-2.4,0-4.3-0.7-5.6-2.1c-1.4-1.4-2.1-3.3-2.1-5.7c0-2.3,0.6-4.3,1.9-5.8c1.3-1.7,3.1-2.5,5.4-2.5 c2.2,0,3.9,0.8,5.1,2.5C196.4,38.3,196.9,39.9,196.9,41.8 M193.6,40.9c0-1-0.2-1.9-0.7-2.6c-0.6-1-1.5-1.4-2.7-1.4 c-1.1,0-2,0.5-2.7,1.4c-0.6,0.7-0.9,1.6-1,2.7H193.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStoreSeeklogo);
export default __webpack_public_path__ + "static/media/apple-store-seeklogo.fb2ab7ab1af4fcb211e3217123021314.svg";
export { ForwardRef as ReactComponent };